import API from 'services/API';

export default function getInvestAccounts({ pagination, filter, sort }) {
  return API.request({
    method: 'POST',
    url: '/investAccounts',
    data: {
      pagination,
      filter,
      sort,
    },
  });
}
